<template>
    <div>
        <!-- preloader -->
        <div id="preloader">
            <div id="spinner">
                <img src="/images/preloaders/1.gif" alt="">
            </div>
        </div>
        
        <!-- Header -->
        <header id="header" class="header">
            <div class="header-nav navbar-fixed-top header-dark navbar-white navbar-transparent bg-transparent-5 navbar-sticky-animated">
                <div class="header-nav-wrapper">
                    <div class="container">
                        <nav id="menuzord-right" class="menuzord">
                            <a class="pull-left flip logo" href="/"><img src="/images/movement-flow-white-theme.png" alt=""></a>
                            <a class="pull-left flip logo-dark" href="/"><img src="/images/movement-flow-white-theme.png" alt=""></a>
                            <ul class="menuzord-menu">
                                <li :class="{'active': currentRoute == '/'}">
                                    <a href="/">Home</a>
                                </li>
                                <li :class="{'active': currentRoute == '/aboutme'}">
                                    <a href="/aboutme">About Me</a>
                                </li>
                                <li class="category-link" v-for="category in results" :key="category.id" :class="{'active': currentRoute + currentSearch == ('/category?Key=' + category.UrlKey)}">
                                    <a :href="'/category?Key=' + category.UrlKey">{{category.Title}}</a>
                                </li>
                                <li class="categories-dropdown" :class="{'active': currentRoute == '/category'}">
                                    <a href="#">Categorie</a>
                                    <ul class="dropdown">
                                        <li v-for="category in results" :key="category.id" :class="{'active': currentRoute + currentSearch == ('/category?Key=' + category.UrlKey)}">
                                            <a :href="'/category?Key=' + category.UrlKey">{{category.Title}}</a>
                                        </li>
                                    </ul>
                                </li>
                                <li :class="{'active': currentRoute == '/contactme'}">
                                    <a href="/contactme">Contatti</a>
                                </li>
                                <li :class="{'active': currentRoute == '/dashboard'}">
                                    <a href="/dashboard" title="Area utente"><i class="fa fa-user"></i></a>
                                </li>
                                <li v-if="loggedIn">
                                    <a v-on:click.stop.prevent="logout()" class="logout-btn" title="Logout"><i class="fa fa-sign-out"></i></a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<style scoped>
#header .menuzord-menu {
    margin-top: 5px;
}

.menuzord-menu > li > a, 
.menuzord-menu > li > a {
    -o-transition: font-weight .3s linear;
    -moz-transition: font-weight .3s linear;
    -webkit-transition: font-weight .3s linear;
    transition: font-weight .3s linear;
    
    -o-transition: font-size .3s linear;
    -moz-transition: font-size .3s linear;
    -webkit-transition: font-size .3s linear;
    transition: font-size .3s linear;
}
.menuzord-menu > li.active > a, 
.menuzord-menu > li:hover > a {
    background: none;
    color: inherit;
    font-weight: bold;
    /*font-size: 15px;*/
}

.menuzord-menu ul.dropdown li.active a {
    font-weight: bold;
}

#header .logo img,
#header .logo-dark img {
    max-height: 70px;
    margin: 5px 2px 5px 15px;
}

.header-nav:not(.animated-active) .logo{
    display: none;
}
.header-nav.animated-active .logo-dark{
    display: none;
}

.menuzord-menu .logout-btn {
    cursor: pointer;
}

.menuzord-menu .categories-dropdown {
    display: none;
}

@media only screen and (min-width: 993px) {
    .menuzord-menu > li:first-child {
        display: none;
    }

    .menuzord-menu > li > a{
        font-size: 9px;
    }
}
@media only screen and (min-width: 1200px) {
    
    .menuzord-menu > li > a{
        font-size: 11px;
    }
}

@media only screen and (max-width: 1200px) {
    #header .logo img,
    #header .logo-dark img {
        max-height: 60px;
        margin: 8px 2px 8px 10px;
    }

    .menuzord-menu > li > a {
        padding: 8px 12px;
    }
}
@media only screen and (max-width: 992px) {
    #header .logo img,
    #header .logo-dark img {
        max-height: 55px;
        margin: 10px 2px 10px 8px;
    }

    .menuzord-menu > li > a {
        padding: 8px;
    }
    
    #header .menuzord-menu li.category-link {
        display: none;
    }
    #header .menuzord-menu li.categories-dropdown {
        display: initial;
    }
}
@media only screen and (max-width: 768px) {
   
}
</style>

<script>
import axios from 'axios';
import store from '../helper/store' // your vuex store 

export default {
  name: 'Header',
  data () {
    return {
      results: [],
      currentRoute: window.location.pathname,
      currentSearch: window.location.search,
      loggedIn: !(localStorage.getItem('token') == undefined || localStorage.getItem('token') == null || localStorage.getItem('token') == "")
    }
  },
  methods: {
    logout: function() {
        store.dispatch('logout').then(() => {
            //REDIRECT TO LOGIN
            window.location.replace("/login");
            }).catch(err => console.log(err))
    }
  },
  mounted () {
    axios.get(process.env.VUE_APP_API_URL + "/categories?IsVisible=true")
    .then(response => {
      console.log(response.data);
      this.results = response.data
      }
    )
  }
}
</script>
